export default __webpack_public_path__ + "static/media/961.51a251ff.gif";